<div id="app-login-banner">
  <a
    *ngIf="hostname === environment.relutechUrl"
    id="app-login-banner-relutech"
    href="https://nerdrabbit.com/?utm_source=ChannelWorks&utm_medium=Banner&utm_campaign=Login&utm_content=NeedTalentForCloud"
    role="button"
  >
    <div id="app-login-banner-relutech-container"></div>
  </a>
</div>
<div id="app-login-wrapper" [ngSwitch]="hostname">
  <div *ngSwitchDefault id="app-login-wrapper-default">
    <app-index-layout [layoutData]="layoutData">
      <div box-body>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group mb-5">
            <input
              placeholder="Email"
              type="text"
              formControlName="email"
              class="form-control"
              autocomplete="email"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
            />
            <div *ngIf="submitted && !!f.email.errors" class="invalid-feedback">
              <div *ngIf="!!f.email.errors.required">Email is required</div>
              <div *ngIf="!!f.email.errors?.maxlength">Email must have less than 60 characters</div>
              <div *ngIf="!!f.email.errors?.email">Please enter a valid email</div>
            </div>
          </div>
          <div class="form-group">
            <input
              placeholder="Password"
              type="password"
              formControlName="password"
              class="form-control"
              autocomplete="current password"
              [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
            />
            <div *ngIf="submitted && !!f.password.errors" class="invalid-feedback">
              <div *ngIf="!!f.password.errors.required">Password is required</div>
              <div *ngIf="!!f.password.errors?.minlength">Password must be at least 5 characters</div>
            </div>
            <div class="d-flex justify-content-around align-items-center mt-3">
              <a routerLink="/signup">Sign up</a>
              <a routerLink="/forgot" class="btn btn-link pr-0">Forgot password?</a>
            </div>
          </div>
          <div class="form-group-buttons text-center">
            <button class="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </app-index-layout>
  </div>
  <div
    *ngSwitchCase="environment.relutechUrl"
    id="app-login-wrapper-relutech"
    class="row d-flex justify-content-center"
  >
    <div class="container-fluid text-center d-flex justify-content-center">
      <div class="row h-100">
        <div id="app-login-section-one" class="app-login-section col-md">
          <div class="d-flex flex-column justify-content-center h-100">
            <h1 class="text-light">Welcome to the</h1>
            <img class="" src="../../../assets/login/relutech/RAMP%20Logo-01.png" alt="..." />
            <h1 class="text-light">Powered by ReluTech, LLC.</h1>
          </div>
        </div>

        <div id="app-login-section-two" class="app-login-section col-md">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <div class="form-column">
              <div class="form-header pb-3">
                <h1>Login into your account</h1>
              </div>
              <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="form-group mb-5">
                  <label class="input-label-relutech">Email Address *</label>
                  <input
                    type="text"
                    formControlName="email"
                    class="form-control"
                    autocomplete="email"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                  />
                  <div *ngIf="submitted && !!f.email.errors" class="invalid-feedback">
                    <div *ngIf="!!f.email.errors.required">Email is required</div>
                    <div *ngIf="!!f.email.errors?.maxlength">Email must have less than 60 characters</div>
                    <div *ngIf="!!f.email.errors?.email">Please enter a valid email</div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-label-container">
                    <label class="input-label-relutech">Password *</label>
                    <a routerLink="/forgot" class="">Forgot password?</a>
                  </div>
                  <input
                    type="password"
                    formControlName="password"
                    class="form-control"
                    autocomplete="current password"
                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                  />
                  <div *ngIf="submitted && !!f.password.errors" class="invalid-feedback">
                    <div *ngIf="!!f.password.errors.required">Password is required</div>
                    <div *ngIf="!!f.password.errors?.minlength">Password must be at least 5 characters</div>
                  </div>
                </div>
                <div class="form-group-buttons text-center d-flex justify-content-end align-items-end flex-column">
                  <button class="btn btn-primary btn-relutech">Log In</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
